module.exports = __webpack_public_path__ + "static/media/be.f34903cc.svg";